import { Component, Host, h, JSX, Prop } from '@stencil/core';

@Component({
  tag: 'bundle-summary-discount'
})
export class BundleSummaryDiscount {
  @Prop() public highlightMonthlyTotalSavings = false;
  @Prop() public monthlyTotal: string;
  @Prop() public monthlyTotalSavings: string;
  @Prop() public monthlyTotalSubText: string;

  public render(): JSX.Element {
    return (
      <Host>
        <agl-ds-p bottom-margin="none" font="fontfamily02" styled-as="sm">
          Monthly total
        </agl-ds-p>
        <agl-ds-p bottom-margin="space02">
          <agl-ds-text font-weight="semibold" styled-as="lg">
            {this.monthlyTotal} {this.monthlyTotalSubText}
          </agl-ds-text>
        </agl-ds-p>
        <agl-ds-p bottom-margin="none" font="fontfamily02" styled-as="sm">
          Total monthly savings
        </agl-ds-p>
        <agl-ds-p bottom-margin="space02">
          <agl-ds-text
            {...(this.highlightMonthlyTotalSavings ? { appearance: 'secondary-highlight' } : {})}
            font-weight="semibold"
            styled-as="lg"
          >
            {this.monthlyTotalSavings}
          </agl-ds-text>
        </agl-ds-p>
      </Host>
    );
  }
}
